import { render, staticRenderFns } from "./personalCommissionDetall.vue?vue&type=template&id=3c92df50&scoped=true&"
import script from "./personalCommissionDetall.vue?vue&type=script&lang=js&"
export * from "./personalCommissionDetall.vue?vue&type=script&lang=js&"
import style0 from "./personalCommissionDetall.vue?vue&type=style&index=0&id=3c92df50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92df50",
  null
  
)

export default component.exports